import styled from "styled-components/macro";

import { WidgetHeader } from "../../../../../styled-components/WidgetHeader/WidgetHeader";
import { ExpirySelector } from "../ExpirySelector/ExpirySelector";

export const StyledWidgetHeader = styled(WidgetHeader)``;
